import './featuredBlogPosts.scss';
import * as React from 'react';
import Swiper from 'react-id-swiper';
import useFeaturedBlogPosts from '../../hooks/staticQueries/blog/useFeaturedBlogPosts';
import { useSwiperSlide } from '../../hooks/useSwiperSlide';
import { RoutePaths } from '../../routes';
import { SwiperUtils } from '../../utils/swiper';
import { RMButton } from '../layout/rmButton';
import { SectionTitle } from '../layout/sectionTitle';
import { NavigationButtons } from '../navigation/navigationButtons';
import { BlogPostCard } from './blogPost';
export const FeaturedBlogPosts = () => {
    const { blogPosts } = useFeaturedBlogPosts();
    const swiperProps = React.useMemo(() => ({
        ...SwiperUtils.Config.defaults(),
        ...SwiperUtils.Config.perView(5, {
            1920: 4,
            1380: 3,
            1024: 2,
            720: 1,
            0: 1,
        }),
    }), []);
    const { setSwiper, prevSlide, nextSlide, onFirstSlide, onLastSlide } = useSwiperSlide();
    if (!blogPosts.length)
        return null;
    return (<div className="featured-blog-posts">
      <SectionTitle title="Latest Blog Posts"/>

      <div className="featured-blog-posts-inner">
        <NavigationButtons onClickNext={nextSlide} onClickPrev={prevSlide} canGoNext={!onLastSlide} canGoPrev={!onFirstSlide}/>

        <Swiper {...swiperProps} getSwiper={setSwiper}>
          {blogPosts.map((blog_post) => (<div key={blog_post.title}>
              <BlogPostCard blogPost={blog_post} vertical/>
            </div>))}
        </Swiper>
      </div>

      <RMButton to={RoutePaths.blog.blog()} variant="brand-tertiary-2" className="more-button">
        All Blog Posts
      </RMButton>
    </div>);
};
